import { useEffect, useState } from 'react'
import { OrbitControls as OrbitControlsImpl } from 'three-stdlib'

function RotationButtons() {
  const [controls, setControls] = useState<OrbitControlsImpl | null>(null)

  useEffect(() => {
    // Check for controls periodically until they're available
    const interval = setInterval(() => {
      const ctrl = (window as any).__orbit_controls__
      if (ctrl) {
        setControls(ctrl)
        clearInterval(interval)
      }
    }, 100)

    return () => clearInterval(interval)
  }, [])

  const animateRotation = (deltaAzimuth: number, duration: number = 300) => {
    if (!controls) return
    
    const MIN_AZIMUTH = -Math.PI / 2 + 0.1
    const MAX_AZIMUTH = Math.PI / 2 - 0.1
    
    const startAzimuth = controls.getAzimuthalAngle()
    const endAzimuth = Math.max(MIN_AZIMUTH, Math.min(MAX_AZIMUTH, startAzimuth + deltaAzimuth))
    const startTime = performance.now()
    
    const animate = () => {
      const elapsed = performance.now() - startTime
      const progress = Math.min(elapsed / duration, 1)
      
      // Easing function for smooth animation
      const easeOut = 1 - Math.pow(1 - progress, 3)
      
      const currentAzimuth = startAzimuth + (endAzimuth - startAzimuth) * easeOut
      // Clamp during animation to respect limits
      const clampedAzimuth = Math.max(MIN_AZIMUTH, Math.min(MAX_AZIMUTH, currentAzimuth))
      controls.setAzimuthalAngle(clampedAzimuth)
      controls.update()
      
      if (progress < 1) {
        requestAnimationFrame(animate)
      }
    }
    
    animate()
  }

  const handleRotateLeft = () => {
    if (controls) {
      // Rotate left - camera rotates clockwise to make bed appear to rotate left
      animateRotation(-Math.PI / 4, 300) // -45 degrees
    }
  }

  const handleRotateRight = () => {
    if (controls) {
      // Rotate right - camera rotates counter-clockwise to make bed appear to rotate right
      animateRotation(Math.PI / 4, 300) // 45 degrees
    }
  }

  return (
    <div className="absolute bottom-4 right-4 z-10">
      <div className="bg-white rounded-full border border-gray-300 overflow-hidden flex flex-row">
        {/* Rotate Left Button */}
        <button
          onClick={handleRotateLeft}
          data-rotate-left
          className="p-3 hover:bg-gray-50 transition-colors flex items-center justify-center border-r border-gray-300"
          aria-label="Rotate left"
        >
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" fill="none">
    <path
      fill="#666"
      fillRule="evenodd"
      d="m7.328 1.414-4 4 4 4-1.414 1.414L.5 5.414 5.914 0z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#666"
      fillRule="evenodd"
      d="M15 7.414a3 3 0 0 0-3-3H2.5v2H12a1 1 0 0 1 1 1v4h2z"
      clipRule="evenodd"
    ></path>
  </svg>
        </button>
        
        {/* Rotate Right Button */}
        <button
          onClick={handleRotateRight}
          className="p-3 hover:bg-gray-50 transition-colors flex items-center justify-center"
          aria-label="Rotate right"
        >
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" fill="none">
    <path
      fill="#666"
      fillRule="evenodd"
      d="m7.672 1.414 4 4-4 4 1.414 1.414L14.5 5.414 9.086 0z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#666"
      fillRule="evenodd"
      d="M0 7.414a3 3 0 0 1 3-3h9.5v2H3a1 1 0 0 0-1 1v4H0z"
      clipRule="evenodd"
    ></path>
  </svg>
        </button>
      </div>
    </div>
  )
}

export default RotationButtons

